import { useState } from 'react';
// contexts
import { useHubspotStatus } from 'context/HubspotStatusContext/HubspotStatusContext';

const useTimerFreeTrial = () => {
    const { statusHubspot } = useHubspotStatus();
    const [hiddenTimerAlert, setHiddenTimerAlert] = useState<boolean>(() => {
        if (typeof window !== 'undefined') {
            const storedValue = localStorage.getItem('hiddenBannerTimer');
            return storedValue ? JSON.parse(storedValue) : false;
        }
        // return false;
    });

    const handleHiddenTimerAlert = () => {
        setHiddenTimerAlert(true);
        localStorage.setItem('hiddenBannerTimer', JSON.stringify(true));
    };

    return { statusHubspot, hiddenTimerAlert, handleHiddenTimerAlert };
};

export default useTimerFreeTrial;
